<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout
      v-if="hasRole('financial', 'ROLE_PUT_ORDER_REPROCESS_MASSIVE') && isValidArray(selectedItems) && selectedItems.length === 1"
      align-center
      row
    >
      <v-spacer />
      <v-btn
        color="accent"
        class="action-bar__btn"
        round
        depressed
        @click="handleReprocessThisInvoice"
      >
        {{ $t(`${namespace}.reprocessThisInvoice`) }}
      </v-btn>
    </v-layout>

    <v-layout
      v-if="isValidArray(selectedItems) && selectedItems.length > 1"
      align-center
      row
    >
      <v-spacer />

      <!-- v-if="isValidObject(pagination) && pagination.itemsPerPage === selectedItems.length" -->
      <a
        v-if="hasRole('financial', 'ROLE_PUT_ORDER_REPROCESS_PERIOD')"
        href="#"
        class="action-bar__link"
        @click.prevent="handleReprocessAllDeclinedInvoices"
      >
        {{ $t(`${namespace}.reprocessAllDeclinedInvoices`) }}
      </a>

      <v-btn
        v-if="hasRole('financial', 'ROLE_PUT_ORDER_REPROCESS_MASSIVE')"
        color="accent"
        class="action-bar__btn"
        round
        depressed
        @click="handleReprocessSelectedInvoices"
      >
        {{ $t(`${namespace}.reprocessSelectedInvoices`) }}
      </v-btn>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { isArray, isObject, hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'

export default {
  name: 'ActionBar',
  props: {
    selectedItems: {
      type: Array,
      required: true
    },

    pagination: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Breadcrumb
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.ManualRetrieval',
      breadcrumbItems: [
        { name: 'Financial', title: this.$t('Components.MainMenu.financial') },
        { name: 'ManualRetrieval', title: this.$t('Components.MainMenu.manualRetrieval') }
      ]
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidArray (val) {
      return isArray(val)
    },

    isValidObject (val) {
      return isObject(val)
    },

    handleReprocessThisInvoice () {
      this.$emit('reprocessThisInvoice')
    },

    handleReprocessAllDeclinedInvoices () {
      this.$emit('reprocessAllDeclinedInvoices')
    },

    handleReprocessSelectedInvoices () {
      this.$emit('reprocessSelectedInvoices')
    }
  }
}
</script>
